import Api from './api';
export const getCalledFlows = async () => { 
  let data = [];
  await Api.get('/calledflows')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};

export const getStatuses = async () => { 
  let data = [];
  await Api.get('/statuses')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};
